/**
 * @Author: Li, Yu Jia
 * @Date: 2020-03-10 19:03:22
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2021-04-26 15:40:13
 */

import { userImageType } from '../utils/constants';

export const SAVED_GRID_PAGESIZE = 4;
export const SAVED_GRID_COLUMNCOUNT = 2;
export const STOCK_GRID_PAGESIZE = 9;
export const STOCK_GRID_COLUMNCOUNT = 3;
export const RECENT_GRID_PAGESIZE = 4;
export const RECENT_GRID_COLUMNCOUNT = 2;
export const SLOGAN_GRID_PAGESIZE = 9;
export const SLOGAN_GRID_COLUMNCOUNT = 3;
export const VERSE_GRID_PAGESIZE = 6;
export const VERSE_GRID_COLUMNCOUNT = 2;

export const labelDict = {
  [userImageType.StockArt]: 'Stock Art Name:',
  [userImageType.Slogan]: 'Slogan Name:',
  [userImageType.SharedArt]: 'Saved Art Name:',
  [userImageType.SavedArt]: 'Saved Art Name:',
  [userImageType.Verse]: 'Verse Name:',
  [userImageType.Sentiment]: 'Sentiment Name:',
};

export const titleDict = {
  [userImageType.StockArt]: 'Edit Stock Art & Mascots',
  [userImageType.Slogan]: 'Edit Slogan',
  [userImageType.SharedArt]: 'Edit Saved Art',
  [userImageType.SavedArt]: 'Edit Saved Art',
  [userImageType.Verse]: 'Edit Verse',
  [userImageType.Sentiment]: 'Edit Sentiment',
};

export const selectedTitleDict = {
  [userImageType.StockArt]: 'Selected Stock Art & Mascots',
  [userImageType.Slogan]: 'Selected Slogan',
  [userImageType.SharedArt]: 'Selected Saved Art',
  [userImageType.SavedArt]: 'Selected Saved Art',
  [userImageType.Verse]: 'Selected Verse',
  [userImageType.Sentiment]: 'Selected Sentiment',
};

export const buttonDict = {
  [userImageType.StockArt]: {
    changeIcon: 'stockart',
    changeText: 'Change Stock Art or Mascot',
  },
  [userImageType.Slogan]: {
    changeIcon: 'slogan',
    changeText: 'Change Slogan',
  },
  [userImageType.SharedArt]: {
    changeIcon: 'savedartwork',
    changeText: 'Change Saved Art',
  },
  [userImageType.SavedArt]: {
    changeIcon: 'savedartwork',
    changeText: 'Change Saved Art',
  },
  [userImageType.Verse]: {
    changeIcon: 'verse',
    changeText: 'Change Verse',
  },
  [userImageType.Sentiment]: {
    changeIcon: 'sentiment',
    changeText: 'Change Sentiment',
  },
};

export const removeLinkTextDict = {
  [userImageType.StockArt]: 'Remove Stock Art & Mascots',
  [userImageType.Slogan]: 'Remove Slogan',
  [userImageType.SharedArt]: 'Remove Saved Art',
  [userImageType.SavedArt]: 'Remove Saved Art',
  [userImageType.Verse]: 'Remove Verse',
  [userImageType.Sentiment]: 'Remove Sentiment',
};

export const cancelApplyCaptionDefault = {
  cancel: 'Cancel',
  apply: 'Apply',
  applyAll: 'Apply to All',
};

export const changeFromPreviewAction = {
  None: -1,
  Color: 0,
  UserImage: 1,
};

export const userImageStatus = {
  Normal: -1,
  Single: 0,
  AutoVerse: 1,
};

export const mandatoryMissingWarning = {
  [userImageType.Slogan]: 'Please make a Slogan selection for the item to continue.',
  [userImageType.Verse]: 'Please make a Verse selection for the item to continue.',
  [userImageType.Sentiment]: 'Please make a Sentiment selection for the item to continue.',
};

export const ART_CAN_NOT_USED_MESSAGE = 'Sorry, the art you chose can not be used at this time! Please try another one.';